import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaBars, FaTimes, FaUser, FaSignOutAlt } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { user, logout, isAuthenticated } = useAuth();

  const navItems = [
    {
      key: 'home',
      to: '/',
      label: 'Home',
      isActive: (loc) => loc.pathname === '/' && (!loc.hash || loc.hash === '')
    },
    {
      key: 'about',
      to: { pathname: '/', hash: 'about-academy' },
      label: 'About us',
      isActive: (loc) => loc.hash === '#about-academy'
    },
    {
      key: 'courses',
      to: '/courses',
      label: 'Courses',
      isActive: (loc) => loc.pathname.startsWith('/courses')
    },
    {
      key: 'contact',
      to: '/contact',
      label: 'Contact',
      isActive: (loc) => loc.pathname.startsWith('/contact')
    }
  ];

  const handleLogout = () => {
    logout();
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar" aria-label="Main navigation">
      <div className="container navbar-container">
        <div className="navbar-content">
          <Link
            to="/"
            className="navbar-logo"
            aria-label="GL Jewel Academy — Powered By Kapil Jewellers Since 1990"
          >
            <img
              src="/images/gl-jewel-academy-logo.png"
              alt=""
              className="navbar-logo-img"
              width={48}
              height={48}
              decoding="async"
            />
            <span className="navbar-brand-text">
              <span className="logo-text">GL Jewel Academy</span>
              <span className="navbar-brand-tagline">Powered By Kapil Jewellers Since 1990</span>
            </span>
          </Link>

          <div className="navbar-nav desktop-nav" role="navigation">
            {navItems.map((item) => (
              <Link
                key={item.key}
                to={item.to}
                className={`nav-link ${item.isActive(location) ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="navbar-actions desktop-actions">
            {isAuthenticated ? (
              <div className="user-menu">
                <div className="user-info">
                  <FaUser className="user-icon" aria-hidden />
                  <span className="user-name">
                    {user?.firstName} {user?.lastName}
                  </span>
                </div>
                <button type="button" onClick={handleLogout} className="logout-btn">
                  <FaSignOutAlt aria-hidden />
                  Logout
                </button>
              </div>
            ) : (
              <>
                <Link to="/auth" className="nav-signin">
                  Sign in
                </Link>
                <Link to="/courses" className="btn btn-primary btn-nav-cta">
                  Apply now
                </Link>
              </>
            )}
          </div>

          <button
            type="button"
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-nav-panel"
            aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        <motion.div
          id="mobile-nav-panel"
          className={`mobile-nav ${isMenuOpen ? 'open' : ''}`}
          initial={false}
          animate={{ height: isMenuOpen ? 'auto' : 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="mobile-nav-content">
            {navItems.map((item) => (
              <Link
                key={item.key}
                to={item.to}
                className={`mobile-nav-link ${item.isActive(location) ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}

            {!isAuthenticated && (
              <>
                <Link
                  to="/auth"
                  className="mobile-nav-link mobile-signin"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Sign in
                </Link>
                <Link
                  to="/courses"
                  className="mobile-auth-btn"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Apply now
                </Link>
              </>
            )}

            {isAuthenticated && (
              <div className="mobile-user-info">
                <div className="mobile-user-details">
                  <FaUser className="mobile-user-icon" aria-hidden />
                  <span>
                    {user?.firstName} {user?.lastName}
                  </span>
                </div>
                <button type="button" onClick={handleLogout} className="mobile-logout-btn">
                  <FaSignOutAlt aria-hidden />
                  Logout
                </button>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </nav>
  );
};

export default Navbar;
